import { z } from 'zod';
import { SanityDocumentSchema, SanityAssetSourceSchema, SanityImageAssetSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';

export const ImageObjectSchema = z.object({
  asset: SanityAssetSourceSchema
});

export const ImageAssetSchema = z.object({
  asset: SanityImageAssetSchema
});

export const ImageSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Image),
  name: z.string(),
  image: ImageAssetSchema.nullish()
});

export type ImageObject = z.infer<typeof ImageObjectSchema>;
export type ImageAsset = z.infer<typeof ImageAssetSchema>;
export type Image = z.infer<typeof ImageSchema>;
